// extracted by mini-css-extract-plugin
module.exports = {"link":"_1QJUd","root":"_1sXY0","label":"FZdzR"};